import React, { useState, useEffect, useMemo } from 'react';
import { Box, Typography, Divider, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Input } from 'components/layout';
import { useForm, FormProvider } from 'react-hook-form';


const policies = {
  endEvent: {
    name: 'endEvent',
    input: 'switch',
    label: 'workflowEdit.components.task.form.add.endEvent'
  },
  type: {
    name: 'type',
    input: 'autocomplete',
    label: 'workflowEdit.components.task.form.add.type',
  },
  action: {
    name: 'action',
    input: 'select',
    label: 'workflowEdit.components.task.form.add.action',
  },
  satisfy: {
    name: 'satisfy',
    input: 'select',
    label: 'workflowEdit.components.task.form.add.satisfy.label',
  },
}

const optionsSatisfy = [
  { value: "T", label: 'workflowEdit.components.task.form.add.satisfy.optionAll' },
  { value: "A", label: 'workflowEdit.components.task.form.add.satisfy.optionSome' }
];


export default function AddTaskComponent({ task, optionsType, optionsAction, handleCancel, counterNode, handleAdd }) {
  const [t] = useTranslation();
  const methods = useForm({
    defaultValues: {
      endEvent: false,
      type: optionsType[0].value,
      action: optionsAction[0].value,
      satisfy: optionsSatisfy[0].value
    }
  });
  const { handleSubmit, watch } = methods;
  const watchEndEvent = watch('endEvent');

  function handleOnSubmit(data) {

    if (data.endEvent) {
      const objectNodeEndEvent = {
        id_nodo: counterNode + 1,
        id_Plantilla: 0,
        title: "FINALIZAR",
        description: "FI",
        type: "FI",
        hasUserAction: "",
        childs: [],
        conn: [
          {
            conx: data.action,
            id_nodo: task.id_nodo
          }
        ],
        ifCon: data.satisfy
      }
      handleAdd(objectNodeEndEvent, task.id_nodo);
      return;
    }

    const typeFound = optionsType.find(element => element.value === data.type);

    if (!typeFound) return;

    const objectNode = {
      id_nodo: counterNode + 1,
      id_Plantilla: typeFound.value,
      title: typeFound.label,
      description: typeFound.type_template,
      type: typeFound.type,
      hasUserAction: typeFound.user_interaction,
      childs: [],
      conn: [
        {
          conx: data.action,
          id_nodo: task.id_nodo
        }
      ],
      actions: true
    };

    handleAdd(objectNode, task.id_nodo);
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
      <FormProvider { ...methods }>
        <form onSubmit={handleSubmit(handleOnSubmit)}>
          <Box sx={{ display: 'flex', p: 2, flexDirection: 'column', gap: 2 }}>
            <Typography variant="h6">{t('workflowEdit.components.task.addLabel')}</Typography>
            <Divider />
            <Input {...policies.endEvent} position="horizontal" />
            <Divider/>

            <Input
              {...policies.satisfy}
              options={optionsSatisfy}
              sx={{ width: '100%' }}
              disabled={!watchEndEvent}
              display={watchEndEvent ? 'inherit' : 'none'}
            />
            <Input
              {...policies.type}
              options={optionsType}
              sx={{ width: '100%' }}
              disabled={watchEndEvent}
              display={watchEndEvent ? 'none' : 'inherit'}
            />
            <Input
              {...policies.action}
              options={optionsAction}
              sx={{ width: '100%' }}
            />
            <Divider/>
            <Button variant="outlined" sx={{ width: '100%' }} type='submit'>
              {t('workflowEdit.components.task.form.save')}
            </Button>
          </Box>
        </form>
      </FormProvider>

      <Box sx={{ display: 'flex', px: 2, pb: 4, gap: 1 }}>
        <Button variant="text" sx={{ width: '100%' }} onClick={handleCancel}>
          {t('workflowEdit.components.task.form.cancel')}
        </Button>
      </Box>
    </Box>
  );
}
